import { Box, Divider, Grid, IconButton, Typography, useScrollTrigger } from "@mui/material";
import Product from "features/clients/Purchase/Sets/Product/Product";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { transformData, transformDataForTrayModal } from "utils/transformdata";

import apiClient from "lib/api-client";
import { useGlobalContext } from "context/GlobalContext";
import InfoModal from "components/ui/InfoModal/InfoModal";
import { getSinglePartialSetDesigns, usePartialSetsDesign } from "../../Sets/Api/api";
import { useClientContext } from "context/ClientContext";
import { ReactComponent as DownArrow } from "../../../../../assets/icons/Arrowdown.svg";
import { useLocation, useParams } from "react-router-dom";
import SortContext from "context/SortContext";

function DesignType({ type, designs, data }) {
  const [open, setOpen] = useState(true);
  const handleToggle = () => setOpen((prev) => !prev);
  const location = useLocation();
  const innerChnages = location?.state?.innerChnages;

  const { setSortOptions } = useContext(SortContext);

  useEffect(() => {
    setSortOptions(["d", "e", "f"]);
    return () => {
      setSortOptions([]);
    };
  }, []);

  return (
    <>
      <Box onClick={handleToggle} sx={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
        <IconButton
          disableFocusRipple
          disableRipple
          sx={{
            transform: open ? "rotate(0deg)" : "rotate(-90deg)",
            transition: "transform 0.2s ease",
          }}
        >
          <DownArrow />
        </IconButton>
        <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "poppins !important",
            fontSize: "18px !important",
            fontWeight: "500 !iimportant",
          }}
        >
          {type} - {designs.length}
        </Typography>
      </Box>

      {open && (
        <Grid
          container
          className="Grid-padding"
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "32px",
            rowGap: "32px",
            maxHeight: "85vh",
            overflow: "auto",
            scrollbarWidth: "none",
          }}
        >
          {designs &&
            designs?.map((design) => {
              const transformedProduct = transformData(design);
              return <Product data={transformedProduct} allData={data?.designs} isBtn={innerChnages ? true : false} />;
            })}
        </Grid>
      )}
    </>
  );
}

function PartialSetsPurchaseDesignPage({ setName, isPartial }) {
  const [purchasedDesign, setPurchasedDesign] = useState([]);
  const [nonPurchasedDesign, setNonPurchasedDesign] = useState([]);
  const { setCreateBtn, createBtn } = useClientContext();

  const { search } = useLocation();
  const setId = new URLSearchParams(search).get("setId");

  const  { clientId } = useParams();

  // const [data, setData] = useState([]);

  // useEffect(() => {
  //   const { set } = getSinglePartialSetDesigns();
  //   setData(set);
  // }, []);

  const { data, isLoading, isError, error } = usePartialSetsDesign({
    clientCode: clientId,
    setId,
    enabled: !!setId,
  });

  const {
    infoModalOpen,
    setInfoModalOpen,
    setDisplayCount,
    setSearchResultCount,
    setIsInfoBtn,
    setFilterChangeCount,
    setFilterChangeDesignCount,
    setSearchSuffix,
    dynamicfilterCount,
    filterChangeCount,
    filterChangeDesignCount,
  } = useGlobalContext();

  const fetchData = () => apiClient.get(`/api/v1/set/getSetWeightInfo/${setId}`);

  useEffect(() => {
    setIsInfoBtn(true);
    setCreateBtn(true);

    return () => {
      setIsInfoBtn(false);
      setCreateBtn(false);
    };
  }, []);

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.designs?.length);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
    }
    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [data]);

  useEffect(() => {
    if (data?.designs?.length) {
      let purchasedData = data.designs.filter((entry) => entry.isPurchase);
      let nonPurchasedData = data.designs.filter((entry) => !entry.isPurchase);
      setPurchasedDesign(purchasedData);
      setNonPurchasedDesign(nonPurchasedData);
    }
  }, [data]);

  return (
    <>
      <div style={{ maxHeight: "85vh", overflow: "auto", scrollbarWidth: "none", width: "100%", overflowX: "hidden" }}>
        <DesignType type={"Purchased"} designs={purchasedDesign} data={data} />
        <Divider sx={{ background: "#0D0D0D", height: "4px", border: "none", margin: "0.7vw -3vw" }} />
        <DesignType type={"Not Purchased"} designs={nonPurchasedDesign} data={data} />
      </div>
      <InfoModal open={infoModalOpen} setOpen={setInfoModalOpen} setDetails={true} fetchData={fetchData} title="Metadata Details" />
    </>
  );
}

export { PartialSetsPurchaseDesignPage, DesignType };
